
<div #modal class="modal" *ngIf="showModal">
    <div class="modal-body">
        <div class="modal-content">
            <div class="close" (click)="close()"><i class="fa-solid fa-circle-xmark"></i>schliessen</div>
            <div class="details">
                <i class="fa-solid fa-circle-info"></i>
                <div class="sub-details">Ihr Warenkorb ist leer.</div>
            </div>
        </div>
        <div class="submit" (click)="close()">Verstanden</div>
    </div>
</div>
